import clsx from 'clsx'
import { format } from 'date-fns'
import Icon from 'lib/components/Icon/Icon'
import {
  CaptionProps,
  useNavigation as useCalendarNavigation,
} from 'react-day-picker'

const navButtonCommonClassnames = clsx(
  'inline-flex items-center justify-center rounded-8',
  // Disabled
  'disabled:text-neutral-500 disabled:cursor-not-allowed',
  // Focus
  'focus-visible:outline-none focus-visible:shadow-input-active',
)

export default function CalendarCaption({ displayMonth }: CaptionProps) {
  const { previousMonth, nextMonth, goToMonth } = useCalendarNavigation()

  return (
    <div className="flex items-center justify-between mb-6 text-neutral-700 px-2 [&_+_*]:w-full">
      <button
        disabled={previousMonth ? false : true}
        className={navButtonCommonClassnames}
        type="button"
        onClick={() => previousMonth && goToMonth(previousMonth)}
      >
        <Icon icon="arrow-left" className="w-5 h-5" />
      </button>
      <span className="type-body-5">{format(displayMonth, 'MMMM yyyy')}</span>
      <button
        disabled={nextMonth ? false : true}
        className={navButtonCommonClassnames}
        type="button"
        onClick={() => nextMonth && goToMonth(nextMonth)}
      >
        <Icon icon="arrow-right" className="w-5 h-5" />
      </button>
    </div>
  )
}
